import { AxiosResponse } from 'axios';
import { endOfDay } from 'date-fns';

import API from '../Api';
import { WeatherDataV2 } from '../types/contract';
import { controller } from '../components/Common/DatePicker';

export const getWeatherAndForecast = async (
  location: string,
  startTime: string,
  endTime: string,
  resolution: string,
): Promise<WeatherDataV2 | undefined> => {
  const startDay = endOfDay(new Date(startTime)).toISOString().substring(0, 10);
  const endDay = endOfDay(new Date(endTime)).toISOString().substring(0, 10);

  const weatherData: AxiosResponse<WeatherDataV2> | undefined = await API({
    signal: controller.signal,
    method: 'get',
    url: `/v2/getWeather/${location}/${startDay}/${endDay}/${resolution}`,
  }).catch(() => undefined);

  return weatherData?.data;
};
